import { deleteCons } from "api";
import { Error } from "utils/Response";
import { GetCons } from "../GetCons/action";
import { ActionTypes } from "./types";
import { GetDecisionDetails } from "../GetDecisionDetails/action";

export const DeleteCons = (Data, id, decisionId) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data, status } = await deleteCons(Data);
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
    if (status === 204) {
      dispatch(GetCons(id));
      dispatch(GetDecisionDetails(decisionId, false));
    }
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
